import { Component, OnInit, ViewChild } from '@angular/core';
import { NaruceneKolicineService } from './narucene-kolicine.service';
import { DxDataGridComponent, DxTagBoxComponent } from 'devextreme-angular';
import { moduli } from '../../config';
import moment from 'moment';
import notify from 'devextreme/ui/notify';
import { Router } from '@angular/router';

@Component({
  selector: 'app-narucene-kolicine',
  templateUrl: './narucene-kolicine.component.html',
  styleUrls: ['./narucene-kolicine.component.scss'],
})
export class NaruceneKolicineComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  @ViewChild('tablicaLinije', { static: false })
  dataLinije: DxDataGridComponent;
  @ViewChild('tagBox', { static: false }) tagBox: DxTagBoxComponent;

  now: Date = new Date();
  currentValue: Date = new Date();
  odabranDatum = false;
  razdobljeOd: any;
  razdobljeDo: any;
  datumOd: any;
  datumDo: any;
  datumOd_za_slanje: any;
  datumDo_za_slanje: any;
  idProizvoda: number;
  sifraProizvoda: number;
  proizvodi: any;
  nabavljaci: any;
  planiraj = false;
  odabranTjedan: any;
  startEditAction: string = 'click';
  selectTextOnEditStart: boolean = true;
  linije: any;
  odabranaSmjena = false;
  potrebnoProizvesti: number;
  uPlanu: number;
  potrebnoJos: number;
  djelatnici: any;
  datumSmjene: any;
  idSmjene: any;
  poruka = 'Učitavanje...';
  porukaNabavljaci = 'Učitavanje...';
  porukaLinije = 'Učitavanje...';
  datumOdabran = false;
  datumPregleda: any;
  uPlanuLinije: number;
  uPlanuTmp: number;
  uPlanuTmpPrikazi: boolean;
  uPlanuValue: number;
  prijedlogPlanaValue: number;
  expandedRow = false;
  rowIndex: number;
  pageIndex: number;
  dataIndex: number;
  smjenaE: any;
  smjenaD: any;
  smjenaS: any;
  spremanjePlanaPoruka: string;
  postojiPolovicnaPaleta = false;
  polovicnePalete: any;
  nadopuni = false;
  nadopuniPlanId: number = null;
  tjedan: number;
  nedjelja = moment().day(0).format('YYYY-MM-DD');
  petak = moment().day(5).format('YYYY-MM-DD');
  
    // PRAVA KORISNIKA
    pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
    trenutniPogled: any;
    pravaZaTrenutniPogled: any;
    prikaziStranicu = 0;
    // KRAJ PRAVA KORISNIKA


  constructor(
    private service: NaruceneKolicineService,
    private router: Router
  ) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().naruceneKolicine;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.tjedanUGodini(this.nedjelja, this.petak);
  }

  dohvatiDjelatnike(tjedan, smjena) {
    this.service
      .dohvatiDjelatnike({ tjedanugodini: tjedan, smjena: smjena })
      .subscribe((res) => {
        console.log(res);
        this.djelatnici = [];
        // this.djelatnici = res.data;
        for (let djelatnik of res.data) {
          this.djelatnici.push({
            name: djelatnik.ld_djelatnik,
            id: djelatnik.idlinijadjelatnik,
          });
        }
        console.log(this.djelatnici);
      });
  }

  tjedanUGodini(nedjelja, petak) {
    this.service
      .tjedanUGodini({ datumod: nedjelja, datumdo: petak })
      .subscribe((res) => {
        console.log(res);
        this.tjedan = res.data[0].tjedanugodini;
        console.log(this.tjedan);
      });
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.datumOd_za_slanje = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.datumOd_za_slanje + " " + this.datumDo_za_slanje);
    if (this.datumDo_za_slanje) {
      this.dohvatiNaruceno();
    }
  }

  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.datumDo_za_slanje = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.datumOd_za_slanje + " " + this.datumDo_za_slanje);
    if (this.datumOd_za_slanje) {
      this.dohvatiNaruceno();
    }
  }

  // Promjena datuma u kalendaru
  onValueChanged(e) {
    this.datumPregleda = e.value;
    this.datumOdabran = true;
    let datumod = moment(e.value).format('YYYY-MM-DD');
    let datumdo = moment(datumod).add(6, 'day').format('YYYY-MM-DD');
    let objekt = { datumod: datumod, datumdo: datumdo };
    // console.log(objekt);

    if (this.planiraj == true) {
      this.dataGrid.instance.clearFilter();
      this.planiraj = false;
      this.odabranaSmjena = false;
    }

    this.proizvodi = [];
    this.service.dohvatiNaruceno(objekt).subscribe((res) => {
      console.log(res);
      if (res.data[0].length == 0) {
        this.poruka = 'Nema podataka za ovaj period!';
      } else {
        this.poruka = 'Učitavanje...';
      }
      this.razdobljeOd = moment(datumod).format('DD.MM.YYYY.');
      this.razdobljeDo = moment(datumdo).format('DD.MM.YYYY.');
      this.datumOd = objekt.datumod;
      this.datumDo = objekt.datumdo;
      for (let data of res.data[0]) {
        this.proizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          narucenaKolicina:
            data.narucenakolicina == null ? 0 : data.narucenakolicina,
          trenutnoStanje: data.trenutnostanje == null ? 0 : data.trenutnostanje,
          potrebnoProizvesti:
            data.potrebnoproizvesti == null ? 0 : data.potrebnoproizvesti,
          uPlanu: data.uplanu == null ? 0 : data.uplanu,
          narucenoUPaletama: data.kartonpaleta == null ? 0 : data.kartonpaleta,
          prijedlogPlana: data.prijedlogplana == null ? 0 : data.prijedlogplana,
        });
      }
      console.log(this.proizvodi);
    });
  }

  // bilo pozvano na OnInit da prikaže neke podatke za rad, sad je promjenjeno na dinamički datum no i dalje služi za refresh u 'Planiraj' prikazu
  dohvatiNaruceno() {
    this.datumOdabran = true;
    //let datumod = moment(this.datumPregleda).format('YYYY-MM-DD');
    //let datumdo = moment(datumod).add(6, 'day').format('YYYY-MM-DD');
    //let objekt = { datumod: datumod, datumdo: datumdo };
    let objekt = { datumod: this.datumOd_za_slanje, datumdo: this.datumDo_za_slanje };
    this.proizvodi = [];
    this.service.dohvatiNaruceno(objekt).subscribe((res) => {
      console.log(res);
      if (res.data[0].length == 0) {
        this.poruka = 'Nema podataka za odabrani period!';
      } else {
        this.poruka = 'Učitavanje...';
      }
      if (res.success === true) {
        //this.razdobljeOd = moment(datumod).format('DD.MM.YYYY.');
        //this.razdobljeDo = moment(datumdo).format('DD.MM.YYYY.');
        this.razdobljeOd = moment(this.datumOd).format('DD.MM.YYYY.');
        this.razdobljeDo = moment(this.datumDo).format('DD.MM.YYYY.');
        this.datumOd = objekt.datumod;
        this.datumDo = objekt.datumdo;
        this.proizvodi = [];
        for (let data of res.data[0]) {
          this.proizvodi.push({
            id: data.ar_id,
            sifra: data.ar_sifra,
            naziv: data.ar_naziv,
            narucenaKolicina:
              data.narucenakolicina == null ? 0 : data.narucenakolicina,
            trenutnoStanje:
              data.trenutnostanje == null ? 0 : data.trenutnostanje,
            potrebnoProizvesti:
              data.potrebnoproizvesti == null ? 0 : data.potrebnoproizvesti,
            uPlanu: data.uplanu == null ? 0 : data.uplanu,
            narucenoUPaletama:
              data.kartonpaleta == null ? 0 : data.kartonpaleta,
            prijedlogPlana:
              data.prijedlogplana == null ? 0 : data.prijedlogplana,
          });
        }
        console.log(this.proizvodi);
      }
    });
  }

  onRowClick(e) {
    // console.log(e);
    let _this = this;
    let key = e.component.getKeyByRowIndex(e.rowIndex);
    this.sifraProizvoda = key;
    this.idProizvoda = e.data.id;
    this.potrebnoProizvesti = e.data.potrebnoProizvesti;
    this.uPlanu = e.data.uPlanu;
    if (this.uPlanu >= this.potrebnoProizvesti) {
      this.potrebnoJos = 0;
    } else {
      this.potrebnoJos = this.potrebnoProizvesti - this.uPlanu;
    }
    // console.log(this.sifraProizvoda);
    let objekt = {
      datumod: this.datumOd,
      datumdo: this.datumDo,
      idartikl: e.data.id,
    };
    this.nabavljaci = [];
    this.service.dohvatiNabavljace(objekt).subscribe((res) => {
      console.log(res);
      if (res.data.length == 0) {
        this.porukaNabavljaci = 'Nema nabavljača za ovaj proizvod!';
      } else {
        this.porukaNabavljaci = 'Učitavanje...';
      }
      this.nabavljaci = [];
      for (let data of res.data) {
        this.nabavljaci.push({
          sifra: data.pa_sifra,
          narucitelj: data.pa_naziv,
          idNarucitelj: data.pa_id,
          narucenaKolicina: data.naruceno == null ? '0' : data.naruceno,
          min: data.mm_minkolicina == null ? '0' : data.mm_minkolicina,
          max: data.mm_maxkolicina == null ? '0' : data.mm_maxkolicina,
          datumNarudzbe: moment(data.date_value).format('DD.MM.YYYY.'),
          datumUtovara: moment(data.datumutovara).format('DD.MM.YYYY.'),
          prijedlogPlana:
            data.prijedlogplana == null ? '0' : data.prijedlogplana,
        });
      }
      console.log(this.nabavljaci);
      this.potrebnoProizvesti = this.nabavljaci
        .map((item) => item.prijedlogPlana)
        .reduce((prev, next) => prev + next);
      console.log(this.potrebnoJos);
      console.log(this.uPlanu);
      console.log(this.potrebnoProizvesti);
    });

    this.dataIndex = e.dataIndex;
    if (this.expandedRow) {
      e.component.expandRow(key);
    } else {
      e.component.collapseRow(key);
    }

    for (let cell of e.cells) {
      if (cell.rowType == 'data' && cell.columnIndex == 9) {
        // console.log(cell);
        if (this.planiraj) {
          console.log(e.data.id);
          this.pageIndex = this.dataGrid.instance.pageIndex();
          this.dataGrid.instance.filter([['sifra', '=', key]]);
        } else {
          // this.dataGrid.instance.clearFilter();
        }
      }
    }
  }

  onCellClick(e) {
    if (e.rowType == 'data' && e.columnIndex == 8) {
      // console.log(e);
      if (e.row.isExpanded) {
        this.expandedRow = false;
      } else {
        this.expandedRow = true;
      }
      // if (this.dataIndex == undefined) {
      //   console.log("You clicked for the first time!")
      // } else if (this.dataIndex == e.row.dataIndex) {
      //   console.log("You clicked on same row!");
      // } else {
      //   console.log("You clicked on different row!");
      // }
    }
  }

  planirajBtn() {
    this.planiraj = true;
    // prikaz datuma i dana
    let day1 = moment(this.datumOd);
    let day2 = moment(this.datumOd).add(1, 'day');
    let day3 = moment(this.datumOd).add(2, 'day');
    let day4 = moment(this.datumOd).add(3, 'day');
    let day5 = moment(this.datumOd).add(4, 'day');
    let day6 = moment(this.datumOd).add(5, 'day');
    let day7 = moment(this.datumOd).add(6, 'day');
    this.odabranTjedan = {
      day1datum: moment(day1).format('DD.MM.YYYY.'),
      day1ime: moment(day1).locale('hr').format('dddd'),
      day2datum: moment(day2).format('DD.MM.YYYY.'),
      day2ime: moment(day2).locale('hr').format('dddd'),
      day3datum: moment(day3).format('DD.MM.YYYY.'),
      day3ime: moment(day3).locale('hr').format('dddd'),
      day4datum: moment(day4).format('DD.MM.YYYY.'),
      day4ime: moment(day4).locale('hr').format('dddd'),
      day5datum: moment(day5).format('DD.MM.YYYY.'),
      day5ime: moment(day5).locale('hr').format('dddd'),
      day6datum: moment(day6).format('DD.MM.YYYY.'),
      day6ime: moment(day6).locale('hr').format('dddd'),
      day7datum: moment(day7).format('DD.MM.YYYY.'),
      day7ime: moment(day7).locale('hr').format('dddd'),
    };
    // console.log(this.odabranTjedan);
    setTimeout(function () {
      var days = [].slice.call(document.getElementsByClassName('day-name'));
      // console.log(days);
      for (let day of days) {
        if (day.innerHTML == 'nedjelja') {
          day.parentNode.style.background = '#E21A22';
        }
      }
    }, 500);
    this.service
      .dohvatiSmjeneSaPlanom({
        datumod: moment(day1).format('YYYY-MM-DD'),
        datumdo: moment(day7).format('YYYY-MM-DD'),
      })
      .subscribe((res) => {
        console.log(res);
        let smjene = [];
        let dates = [].slice.call(document.getElementsByClassName('day-date'));
        // console.log(dates);
        for (let smjena of res.data) {
          for (let date of dates) {
            if (
              moment(smjena.pp_datumsmjena).format('DD.MM.YYYY.') ==
              date.innerHTML
            ) {
              // console.log(date.parentNode.nextSibling);
              if (smjena.smjena_idsmjena == 1) {
                date.parentNode.nextSibling.childNodes[0].classList.add(
                  'smjenaPopunjena'
                );
              }
              if (smjena.smjena_idsmjena == 2) {
                date.parentNode.nextSibling.childNodes[1].classList.add(
                  'smjenaPopunjena'
                );
              }
              if (smjena.smjena_idsmjena == 3) {
                date.parentNode.nextSibling.childNodes[2].classList.add(
                  'smjenaPopunjena'
                );
              }
            }
          }
        }
      });
  }

  odustaniBtn() {
    this.planiraj = false;
    this.dataGrid.instance.clearFilter();
    this.odabranaSmjena = false;
    console.log(this.pageIndex);
    this.dataGrid.instance.pageIndex(this.pageIndex);
  }

  onRowPrepared(e) {
    // console.log(e);
    if (e.isExpanded) {
      setTimeout(function () {
        e.rowElement.classList.add('active');
      }, 1);
    } else {
      e.rowElement.classList.remove('active');
    }
  }

  onRowExpanding(e) {
    e.component.collapseAll(-1);
  }

  onCellPrepared(options) {
    // console.log(options);
    if (
      options.rowType == 'data' &&
      (options.columnIndex == 5 || options.columnIndex == 6)
    ) {
      // console.log(options);
      options.cellElement.classList.add('size-26');
      if (options.columnIndex == 6) {
        this.uPlanuValue = options.value;
      }
      if (options.columnIndex == 5) {
        this.prijedlogPlanaValue = options.value;
      }
      if (
        options.columnIndex == 6 &&
        this.uPlanuValue < this.prijedlogPlanaValue
      ) {
        options.cellElement.classList.add('upozorenje');
      }
    }
    if (options.rowType == 'data' && options.columnIndex == 0) {
      let target = options.cellElement.childNodes[0];
      target.classList.add('d-none');
    }
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  nadopuniPaletu(e, data) {
    console.log(e);
    console.log(data);
    this.nadopuni = e.value;
    if (this.nadopuni) {
      this.nadopuniPlanId = this.polovicnePalete[0].idPlan;
    } else {
      this.nadopuniPlanId = null;
    }
  }

  nadopuniPlan(e) {
    console.log(e);
    this.nadopuniPlanId = e.value.idPlan;
  }

  // -------------------- Odabir smjene
  odabirSmjene(e, d, s) {
    this.smjenaE = e;
    this.smjenaD = d;
    this.smjenaS = s;

    let nedjelja = moment(d, 'DD.MM.YYYY.').day(0).format('YYYY-MM-DD');
    let petak = moment(d, 'DD.MM.YYYY.').day(5).format('YYYY-MM-DD');
    this.tjedanUGodini(nedjelja, petak);

    // Provjera polovičnih paleta
    this.service
      .provjeraPaleta({ idartikl: this.idProizvoda })
      .subscribe((res) => {
        console.log(res);
        if (res.data.length > 0) {
          this.postojiPolovicnaPaleta = true;
          this.polovicnePalete = [];
          for (let paleta of res.data) {
            this.polovicnePalete.push({
              idPlan: paleta.planproizvodnje_idplanproizvodnje,
              brojKartona: paleta.brojkartonanapolovicnojpaleti,
              maxKartona: paleta.brojkartonazajednupaletu,
              prikaz:
                'Plan: ' +
                paleta.planproizvodnje_idplanproizvodnje +
                ', Kartona: ' +
                paleta.brojkartonanapolovicnojpaleti +
                '/' +
                paleta.brojkartonazajednupaletu +
                ', Broj palete: ' +
                paleta.nd_rednibrojnalepnice,
            });
          }
        } else {
          this.postojiPolovicnaPaleta = false;
        }
      });

    let aktivne = [].slice.call(
      document.getElementsByClassName('aktivnaSmjena')
    );
    for (let aktivna of aktivne) {
      aktivna.classList.remove('aktivnaSmjena');
    }
    e.target.classList.add('aktivnaSmjena');
    let objekt = {
      idartikl: this.idProizvoda,
      datumod: moment(d, 'DD.MM.YYYY.').format('YYYY-MM-DD'),
      smjena: s,
    };
    this.datumSmjene = objekt.datumod;
    this.idSmjene = objekt.smjena;
    if (this.dataLinije != undefined) {
      this.dataLinije.instance.cancelEditData();
    }
    // console.log(objekt);
    this.service.dohvatiProizvodZaPripremuPlana(objekt).subscribe((res) => {
      console.log(res);
      if (res.data.length == 0) {
        this.porukaLinije = 'Nema linija za taj proizvod!';
      } else {
        this.porukaLinije = 'Učitavanje...';
      }
      if (res.success == true) {
        this.dohvatiDjelatnike(this.tjedan, s);
        this.odabranaSmjena = true;
        this.linije = [];
        this.uPlanuLinije = 0;
        let resLinije = res.data;
        for (let data of resLinije) {
          if (data.djelatnici != null) {
            let split = data.djelatnici.split(',');
            var djelatniciArr = [];
            for (let name of split) {
              djelatniciArr.push(name);
            }
          } else {
            var djelatniciArr = [];
          }

          this.linije.push({
            id: data.artikl_ar_id,
            datum: this.datumSmjene,
            smjena: this.idSmjene,
            idplan: data.idplanproizvodnje,
            brojlinije: data.kl_brojlinije,
            linija: data.li_naziv,
            maksimum: data.kl_maxkolicina,
            planirano: data.pp_planiranakolicina,
            djelatnici: djelatniciArr,
            obradeno: data.pp_obradeno,
            napomena: data.pp_napomena,
            idKupac: data.pa_id,
            kupac: data.pa_naziv,
          });
          this.uPlanuLinije = this.uPlanuLinije + data.pp_planiranakolicina;
        }
        console.log(this.linije);
      } else {
        this.odabranaSmjena = false;
      }
    });
  }

  // -------------------- Dx DataGrid Linije
  spremiPromjene(e) {
    console.log(e);
    let djelatniciString = e.data.djelatnici.join(',');
    let djelatniciArray = [];
    let obradjeno;
    for (let djelatnik of e.data.djelatnici) {
      djelatniciArray.push({
        djelatnici: djelatnik,
      });
    }
    if (e.data.idplan != null) {
      obradjeno = e.data.obradeno;
    } else {
      obradjeno = '';
    }
    let objekt = {
      idartikl: e.data.id,
      datumod: e.data.datum,
      smjena: e.data.smjena,
      idplanproizvodnje: e.data.idplan,
      planiranakolicina: e.data.planirano,
      brojlinije: e.data.brojlinije,
      djelatnici: djelatniciArray,
      obradeno: obradjeno,
      napomena: e.data.napomena,
      idpartner: e.data.idKupac,
      nadopuna: e.data.idPalete ? 2 : 0,
      idplannadopuna: e.data.idPalete,
    };
    console.log(objekt);
    if (e.data.planirano && e.data.planirano <= e.data.maksimum) {
      this.service.spremiPlan(objekt).subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          // this.odabirSmjene(this.smjenaE, this.smjenaD, this.smjenaS);
          this.dataLinije.instance.refresh();
          this.dohvatiNaruceno();
          // this.dataGrid.instance.clearFilter();
          this.planiraj = false;
          this.odabranaSmjena = false;
          let aktivne = [].slice.call(
            document.getElementsByClassName('aktivnaSmjena')
          );
          for (let aktivna of aktivne) {
            aktivna.classList.remove('aktivnaSmjena');
          }
          notify('Plan je uspješno spremljen!', 'success', 3000);
        } else {
          notify('Došlo je do pogreške. Plan nije spremljen!', 'danger', 3000);
        }
      });
    } else {
      notify(
        'Za određeni plan nije unešena količina ili je veća od maksimuma linije!',
        'warning',
        4500
      );
    }
  }

  onTagBoxValueChanged(e, data) {
    console.log(e);
    console.log(data);
    this.dataLinije.instance.cellValue(data.rowIndex, 'djelatnici', e.value);
  }

  getCell(e) {
    // console.log(e);
    if (e.rowType == 'totalFooter' && e.columnIndex == 2) {
      let summary = e.summaryItems[0].value;
      this.uPlanuTmp = this.uPlanu - this.uPlanuLinije + summary;
      // console.log(this.uPlanu);
      // console.log(summary);
      // console.log(this.uPlanuTmp);
      if (this.uPlanuTmp >= this.potrebnoProizvesti) {
        this.potrebnoJos = 0;
      } else {
        this.potrebnoJos = this.potrebnoProizvesti - this.uPlanuTmp;
      }
    }
  }

  spremiPlan() {
    // console.log(this.dataLinije);
    this.dataLinije.instance.saveEditData();
  }
}
